var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var BinIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 40,
    glyphHeight: 50
  }), React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M24.4446 0H15.5557C14.3335 0 13.3335 0.978261 13.3335 2.17391V4.34777H2.22222C1 4.34777 0 5.32603 0 6.52169C0 7.71734 1 8.6956 2.22222 8.6956H37.7778C39 8.6956 40 7.71734 40 6.52169C40 5.32603 39 4.34777 37.7778 4.34777H26.6668V2.17391C26.6668 0.978261 25.6668 0 24.4446 0ZM13.3335 39.1306C13.3335 40.3262 14.3335 41.3045 15.5557 41.3045C16.7779 41.3045 17.7779 40.3262 17.7779 39.1306V23.9132C17.7779 22.7175 16.7779 21.7393 15.5557 21.7393C14.3335 21.7393 13.3335 22.7175 13.3335 23.9132V39.1306ZM22.2221 39.1306C22.2221 40.3262 23.2221 41.3045 24.4443 41.3045C25.6665 41.3045 26.6665 40.3262 26.6665 39.1306V23.9132C26.6665 22.7175 25.6665 21.7393 24.4443 21.7393C23.2221 21.7393 22.2221 22.7175 22.2221 23.9132V39.1306ZM8.6778 50H31.3222C33.6111 50 35.5222 48.3153 35.7445 46.087L38.6334 17.8261C38.7556 16.6087 38.3334 15.3913 37.5 14.4783C36.6667 13.5653 35.4667 13.0435 34.2111 13.0435H5.78892C4.54447 13.0435 3.34447 13.5761 2.50003 14.4783C1.65558 15.3805 1.24447 16.6087 1.36669 17.8261L4.25558 46.087C4.4778 48.3153 6.38892 50 8.6778 50ZM8.6778 45.6522L5.78892 17.3913H34.2111L31.3222 45.6522H8.6778Z",
    fill: "black"
  }));
};
export var BinIconGlyph = function (props) {
  return React.createElement(BinIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};